/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import Shell from 'solis/react/layout/shell';

import Overview from 'solis/design-2/pane/overview';
import Dashboard from 'solis/design-2/pane/dashboard';
import BoardPane from 'solis/design-2/pane/board';
import InfluencePane from 'solis/design-2/pane/influence';
import ColonyPane from 'solis/design-2/pane/colony';
import AttachPane from 'solis/design-2/pane/attach';
import DeployPane from 'solis/design-2/pane/deploy';
import SectorGeneratorPane from 'solis/design-2/pane/sector.generator';

import DashboardBody from 'solis/design-2/body/dashboard';
import BoardBody from 'solis/design-2/body/board';
import InfluenceBody from 'solis/design-2/body/influence';
import ColonyBody from 'solis/design-2/body/colony';
import AttachBody from 'solis/design-2/body/attach';
import DeployBody from 'solis/design-2/body/deploy';
import SectorBoard from 'solis/design-2/body/sector.board';

import InfluenceToolbar from 'solis/design-2/toolbar/influence';
import SectorGeneratorToolbar from 'solis/design-2/toolbar/sector.generator';

import Terms from 'solis/claude/legal/terms';
import Privacy from 'solis/claude/legal/privacy';

import BoardTimeBadge from 'solis/claude/header/board.time';
import DeployColonyBadge from 'solis/claude/header/deploy.colony';
import BoardModeSwitcher from 'solis/claude/layout/board.mode.switcher';

import Routes from 'solis/enum/route';


const Config =
{
  [Routes.Overview]:         { layout: [Shell], pane: Overview,                                                                title: 'Overview' },
  [Routes.Dashboard]:        { layout: [Shell], pane: Dashboard,           body: DashboardBody,                                title: 'Dashboard' },
  [Routes.DashboardBoard]:   { layout: [Shell], pane: BoardPane,           body: BoardBody,     toolbar: BoardModeSwitcher,     title: 'Board', badge: BoardTimeBadge, overlay: true },
  [Routes.DashboardInfluence]: { layout: [Shell], pane: InfluencePane,     body: InfluenceBody, toolbar: InfluenceToolbar,      title: 'Create Influence', badge: BoardTimeBadge, overlay: true },
  [Routes.DashboardColony]:  { layout: [Shell], pane: ColonyPane,          body: ColonyBody,                                   title: 'Colony' },
  [Routes.DashboardAttach]:  { layout: [Shell], pane: AttachPane,          body: AttachBody,                                   title: 'Attach Colony' },
  [Routes.Deploy]:           { layout: [Shell], pane: DeployPane,          body: DeployBody,                                   title: 'Deploy', badge: DeployColonyBadge },
  [Routes.SectorGenerator]:  { layout: [Shell], pane: SectorGeneratorPane, body: SectorBoard,   toolbar: SectorGeneratorToolbar, title: 'Sector Generator' },

  [Routes.Terms]:            Terms,
  [Routes.Privacy]:          Privacy,
};


export default Config;
